import { Link } from "react-router-dom";
import { movies, newsArticles, tvshows } from "@/lib/content";

const STATS = [
  { label: "收录电影", value: `${movies.length}+`, icon: "ri-film-line" },
  { label: "收录剧集", value: `${tvshows.length}+`, icon: "ri-tv-2-line" },
  { label: "影视资讯", value: `${newsArticles.length}+`, icon: "ri-newspaper-line" },
  { label: "覆盖题材", value: "20+", icon: "ri-shapes-line" },
];

export default function SiteIntro() {
  return (
    <section className="w-full px-4 py-12 md:px-6 lg:px-10 lg:py-16">
      <div className="grid grid-cols-1 items-center gap-8 overflow-hidden rounded-lg border border-background-200/70 bg-gradient-to-br from-primary-950 via-background-100 to-background-100 p-6 md:p-10 lg:grid-cols-2 lg:gap-12">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/15 px-3 py-1 text-xs font-label text-primary-400">
            <i className="ri-moon-fill" />
            关于夜无疆
          </span>
          <h2 className="mt-4 font-heading text-2xl font-extrabold leading-snug text-foreground-950 md:text-3xl">
            一个专注影视内容展示与资讯推荐的综合平台
          </h2>
          <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-base">
            夜无疆致力于为影视爱好者提供清晰、可靠的作品信息。你可以按类型、地区与年份快速筛选电影与电视剧，查看剧情简介、导演与主演阵容，也能第一时间读到最新的行业动态与深度内容。
          </p>
          <p className="mt-3 text-sm leading-7 text-foreground-600 md:text-base">
            我们坚持「内容优先、查找便捷」的原则，不做繁杂的干扰，让你把时间花在发现好作品上。
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <Link
              to="/movies"
              className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-label text-background-50 transition-colors duration-200 hover:bg-primary-600"
            >
              开始探索
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/news"
              className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 px-6 py-3 text-sm font-label text-foreground-800 transition-colors duration-200 hover:border-primary-500/60 hover:text-primary-400"
            >
              浏览资讯
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {STATS.map((stat) => (
            <div
              key={stat.label}
              className="flex flex-col rounded-lg border border-background-200/70 bg-background-50/70 p-5"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500/15 text-xl text-accent-400">
                <i className={stat.icon} />
              </span>
              <span className="mt-4 font-heading text-2xl font-bold text-foreground-950">{stat.value}</span>
              <span className="mt-1 text-xs text-foreground-500">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}